/* ============================================================
   HOJA — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Header: scroll-hide/show + background ──────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScrollY    = window.scrollY;
    let ticking        = false;

    function updateHeader() {
      const currentY = window.scrollY;
      const scrollingDown = currentY > lastScrollY;

      // Add background once past 60px
      header.classList.toggle('scrolled', currentY > 60);

      // Hide when scrolling down past 120px, show when scrolling up
      if (currentY > 120) {
        header.classList.toggle('header--hidden', scrollingDown);
      } else {
        // Always show near the top
        header.classList.remove('header--hidden');
      }

      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Product size & type selection ─────────────────────── */
  const sizeBtns  = document.querySelectorAll('.size-btn');
  const typeOpts  = document.querySelectorAll('.type-option');
  const priceEl   = document.querySelector('.js-price');
  const variantEl = document.querySelector('[name="id"]');
  const atcBtn    = document.querySelector('.product__atc');

  const prices = window.HOJA_PRICES || {};

  function getSelectedSize() {
    const active = document.querySelector('.size-btn.active');
    return active ? active.dataset.size : null;
  }

  function getSelectedType() {
    const checked = document.querySelector('.type-option input:checked');
    return checked ? checked.value : 'one-time';
  }

  function updatePrice() {
    const size = getSelectedSize();
    if (!size || !prices[size]) return;
    const type  = getSelectedType();
    const entry = prices[size][type];
    if (!entry) return;
    if (priceEl)   priceEl.textContent = '£' + (entry.price / 100).toFixed(2);
    if (variantEl) variantEl.value = entry.variant_id;
  }

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updatePrice();
    });
  });

  typeOpts.forEach(opt => {
    opt.addEventListener('click', () => {
      typeOpts.forEach(o => o.classList.remove('active'));
      opt.classList.add('active');
      opt.querySelector('input').checked = true;
      updatePrice();
    });
  });

  /* ── Add to cart ────────────────────────────────────────── */
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      const variantId = variantEl ? variantEl.value : null;
      if (!variantId) return;

      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          atcBtn.textContent = 'Added ✓';
          setTimeout(() => {
            atcBtn.textContent = 'Shop Now — Add to Bag';
            atcBtn.disabled = false;
          }, 2000);
          updateCartCount();
        } else {
          atcBtn.textContent = 'Shop Now — Add to Bag';
          atcBtn.disabled = false;
        }
      } catch (e) {
        atcBtn.textContent = 'Shop Now — Add to Bag';
        atcBtn.disabled = false;
      }
    });
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      const countEl = document.querySelector('.js-cart-count');
      if (countEl) {
        countEl.textContent = data.item_count > 0 ? `(${data.item_count})` : '';
      }
    } catch (e) {}
  }

  // Load cart count on page load
  updateCartCount();

  /* ── Smooth scroll for same-page anchors ────────────────── */
  // Only fires when already on the homepage (href starts with #, not /#)
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Scroll to anchor after page load (for /#section links) */
  // When navigating from another page via /#origin etc.
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  /* ── Scroll reveal ──────────────────────────────────────── */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => obs.observe(el));
  }

});
